// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width:1152px){.trend-module__container--zde3X{display:flex}}.trend-module__contentWrapper--3qZr8{width:100%;flex-shrink:1}@media screen and (min-width:1152px){.trend-module__contentWrapper--3qZr8{width:calc(100% - 260px);margin-right:20px;border-right:1px solid #e2e2e2;padding-right:20px}}.trend-module__customContainer--oEeTR{padding-top:45px}@media screen and (min-width:1152px){.trend-module__customContainer--oEeTR{padding-top:120px}}", ""]);
// Exports
exports.locals = {
	"container": "trend-module__container--zde3X",
	"contentWrapper": "trend-module__contentWrapper--3qZr8",
	"customContainer": "trend-module__customContainer--oEeTR"
};
module.exports = exports;
